import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
//import {BranchElement} from "../../Models/ApplicationModels/BranchModel";
/// import { RegistrationHealthElement } from "../models/RegistrationHealthModel";
import {ItemMasterHeaderSubDescElement} from "../models/ItemMasterHeaderSubDescModel";


import { environment } from '../../environments/environment';

//   private apiUrl = environment.apiUrl;

@Injectable()
export class ItemMasterHeaderSubDescService {

   //// import { environment } from '../../../environments/environment';
   private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }


  /////////////////////////  ------------  GET ALL ------------


  getAllItemAddon() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllItemMasterHeaderSubDesc",httpOptions);

  //  GetAllItemMasterHeaderSubDesc

  }

  ///////////////////////  ----------- GET ALL BY ID -----------


  getAllItemAddonByHeaderId(  ID:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllItemMasterHeaderSubByHeaderId?ID="+ID,httpOptions);

  //  PROCEDURE    GetAllItemMasterHeaderSubByHeaderId


  }


     getAllItemAddonDescByHeaderId(  ItemId:number, ItemMasterHeaderId:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllItemMasterHeaderSubDescById?ItemId="+ItemId+"&ItemMasterHeaderId="+ItemMasterHeaderId,httpOptions);

  // PROCEDURE   GetAllItemMasterHeaderSubDescById

  }


  

  getAllItemAddonDescResetData(  ItemId:number, ItemMasterHeaderId:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/getAllItemAddonDescReset?ItemId="+ItemId+"&ItemMasterHeaderId="+ItemMasterHeaderId,httpOptions);

  //  PROCEDURE   Cursor_TestParameterResetHeaderIndexWise


  }


  
  getAllItemMasterHeaderSubDescBySubId( ItemId:number,ItemMasterHeaderId:number,ItemMasterHeaderSubId:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
      })
  };
    
  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllItemMasterHeaderSubDescBySubId?ItemId="+ItemId+"&ItemMasterHeaderId="+ItemMasterHeaderId+"&ItemMasterHeaderSubId="+ItemMasterHeaderSubId,httpOptions);

   // return this.http.get("http://localhost:49587/api/ItemMasterAddon/GetAllItemMasterHeaderSubDescBySubId?ItemId="+ItemId+"&ItemMasterHeaderId="+ItemMasterHeaderId+"&ItemMasterHeaderSubId="+ItemMasterHeaderSubId,httpOptions);

  //  PROCEDURE  GetAllItemMasterHeaderSubDescBySubId

  }


  
  getAllItemMasterHeaderSubDescByHeaderIdData( ItemMasterHeaderId:number  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
      })
  };
  
  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllItemMasterHeaderSubDescByHeaderId?ItemMasterHeaderId="+ItemMasterHeaderId,httpOptions);

  //  PROCEDURE   GetAllItemMasterHeaderSubDescByHeaderId

  }


  
  /////////////////////////////  ------------- CURD -----------------


  addItemAddon(app:ItemMasterHeaderSubDescElement) {
    var httpOptions = {
    headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
 
   // http://localhost:49587/
  //  return this.http.post('http://localhost:49587/api/ItemMasterAddon/AddItemMasterHeaderSubDesc',
  
    return this.http.post(""+this.apiUrl+"/ItemMasterAddon/AddItemMasterHeaderSubDesc",
   // return this.http.post('http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/AddItemMasterHeaderSubDesc',
   JSON.stringify(app),
   httpOptions

  )

  //   PROCEDURE   AddItemMasterHeaderSubDesc

  }


  UpdatePathoTestMasterParameterResultDelData(app:ItemMasterHeaderSubDescElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/ItemMasterAddon/UpdatePathoTestMasterParameterResultDel",
  JSON.stringify(app),
   httpOptions
  )

  //  PROCEDURE   UpdatePathoTestMasterParameterResultDelete

  }

  
  UpdatePathoTestMasterParameterResultTruncateData(  InvoiceNOs:string,  skus:string , createdby:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  
  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/UpdatePathoTestMasterParameterResultTruncate?InvoiceNO="+InvoiceNOs+"&SKU="+skus+"&CreatedBy="+createdby,httpOptions);

  //  PROCEDURE   UpdatePathoTestMasterParameterResultTruncate

  }



  updatePathoTestMasterParameterResult(app:ItemMasterHeaderSubDescElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/ItemMasterAddon/UpdatePathoTestMasterParameterResult",
  JSON.stringify(app),
   httpOptions
  )
   
  //  PROCEDURE  UpdatePathoTestMasterParameterResult

  }
   

  

  UploadPathoTestMasterParameterResultBulk(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
  
      })
  };

   
  // return this.http.post<any>("http://localhost:49587/api/ItemMasterAddon/UploadPathoTestMasterParameterResultBulkData", data
   
  return this.http.post<any>(""+this.apiUrl+"/ItemMasterAddon/UploadPathoTestMasterParameterResultBulkData", data
       
   //  PROCEDURE    UpdatePathoTestMasterParameterResultVisibility

        //return this.http.post<any>("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/UploadPathoTestMasterParameterResultBulkData", data
 
       // return this.http.post<any>("http://adminapinew.thenugabest.com:57597/api/PathoBillMasterFinishedReference/UploadBillMasterFinishedReference", data
  
     //, {
    //  reportProgress: true,
   //  observe: 'events'
  //}
  
  );
  }

  UploadPathoTestMasterParameterResultVisible(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
  
      })
  };

   
  // return this.http.post<any>("http://localhost:49587/api/ItemMasterAddon/UploadPathoTestMasterParameterResultBulkData", data
   
  return this.http.post<any>(""+this.apiUrl+"/ItemMasterAddon/UploadPathoTestMasterParameterResultVisibilityData", data
       
   //  PROCEDURE    UpdatePathoTestMasterParameterResultVisibility

        //return this.http.post<any>("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/UploadPathoTestMasterParameterResultBulkData", data
 
       // return this.http.post<any>("http://adminapinew.thenugabest.com:57597/api/PathoBillMasterFinishedReference/UploadBillMasterFinishedReference", data
  
     //, {
    //  reportProgress: true,
   //  observe: 'events'
  //}
  
  );
  }

  
  UploadPathoCommMasterData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
  
      })
  };

      return this.http.post<any>(""+this.apiUrl+"/ItemMasterAddon/UploadPathoCommMaster", data
      
       //   PROCEDURE    UpdatePathoMasterCommResult
     
     // http://localhost:49587/      
    // return this.http.post<any>("http://localhost:49587/api/ItemMasterAddon/UploadPathoCommMaster", data 
  
  );
  }
  
  UploadPathoCommDetailsData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
  
      })
  };

     return this.http.post<any>(""+this.apiUrl+"/ItemMasterAddon/UploadPathoCommDetails", data
    
     ///  PROCEDURE  UpdatePathoDetailsCommResult 

  );
  }

  
  
  getAllTestParameterValuesForEditData(  InvoiceNOs:string, SKUCodes:string  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  //return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);

  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);

  // PROCEDURE   GetAllPathoTestMasterParameterResult

  }


  
  getAllTestParameterValuesForEditDataNewSelection(  InvoiceNOs:string, dept:string , rptdt:string  , skus:string , printcategory:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

    
  // return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);
  
  //return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEditNew?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes+"&ReportDate="+rptdt,httpOptions);

  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllTestParameterValuesForEditNewSelection?InvoiceNO="+InvoiceNOs+"&DEPT="+dept+"&ReportDate="+rptdt+"&SKU="+skus+"&PRINTCAT="+printcategory,httpOptions);

  //   PROCEDURE   GetAllPathoTestMasterParameterResultNewSelectionView

  }
  


  getAllTestParameterValuesForEditDataNew(  InvoiceNOs:string, dept:string , rptdt:string  , skus:string , printcategory:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

    
  // return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);
  
  //return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEditNew?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes+"&ReportDate="+rptdt,httpOptions);


  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllTestParameterValuesForEditNew?InvoiceNO="+InvoiceNOs+"&DEPT="+dept+"&ReportDate="+rptdt+"&SKU="+skus+"&PRINTCAT="+printcategory,httpOptions);
  
  // PROCEDURE   GetAllPathoTestMasterParameterResultNew
  

  }

  
  
  
  getAllTestParameterValuesForEditDataNewRowCount(  InvoiceNOs:string, dept:string , rptdt:string  , skus:string , printcategory:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

    
  // return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);
  
  //return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEditNew?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes+"&ReportDate="+rptdt,httpOptions);

  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllTestParameterValuesForEditNewRowsCount?InvoiceNO="+InvoiceNOs+"&DEPT="+dept+"&ReportDate="+rptdt+"&SKU="+skus+"&PRINTCAT="+printcategory,httpOptions);
  
  //  PROCEDURE  GetAllPathoTestMasterParameterResultNewRowsCount

  

  }
  




  getAllTestParameterValuesTableWise(  InvoiceNOs:string, dept:string , rptdt:string , testcount: Number ,  tblcount: Number ,  skus:string , printcategory:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
    
  // return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);

  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllTestParameterValuesTableWise?InvoiceNO="+InvoiceNOs+"&DEPT="+dept+"&ReportDate="+rptdt+"&TestCount="+testcount+"&TblCount="+tblcount+"&SKU="+skus+"&PRINTCAT="+printcategory,httpOptions);
  
  // PROCEDURE     GetAllTestParameterValuesTableWise  


  }

   
  getAllTestParameterValuesMaxTestCount(  InvoiceNOs:string, dept:string , rptdt:string , skus:string , printcategory:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  //return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);

  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllTestParameterValuesMaxTestCount?InvoiceNO="+InvoiceNOs+"&DEPT="+dept+"&ReportDate="+rptdt+"&SKU="+skus+"&PRINTCAT="+printcategory,httpOptions);
  
  //  PROCEDURE   GetAllPathoTestMasterParameterMaxTestCount



  }


  getAllTestParameterValuesMaxTableCount(  InvoiceNOs:string, dept:string , rptdt:string ,testcount: Number , skus:string , printcategory:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  //return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);

  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllTestParameterValuesMaxTableCount?InvoiceNO="+InvoiceNOs+"&DEPT="+dept+"&ReportDate="+rptdt+"&TestCount="+testcount+"&SKU="+skus+"&PRINTCAT="+printcategory,httpOptions);
  
  //   PROCEDURE  GetAllPathoTestMasterParameterMaxTableCount


  }
  


  
  getAllTestParameterValuesForEditReportDateWiseData(  InvoiceNOs:string, SKUCodes:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  //return this.http.get("http://adminapinew.thenugabest.com:57597/api/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);

  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllTestParameterValuesForEdit?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);
  
  //  GetAllTestParameterValuesForEdit

  }


  
  GetAllPathoTestMasterViewToGenerateReportData(   FROMSS:string, TOSS:string   ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  // return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReport",httpOptions);

  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReport?FromDate="+FROMSS+"&ToDate="+TOSS,httpOptions);
  
  //  PROCEDURE   GetAllPathoTestMasterViewToGenerateReport

  }


  
  GetAllPathoTestMasterViewToGenerateReportCategoryWiseData(   FROMSS:string, TOSS:string , CATEGORY:number  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  // return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReport",httpOptions);

  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReportCategoryWise?FromDate="+FROMSS+"&ToDate="+TOSS+"&Cat="+CATEGORY,httpOptions);
  
  //   PROCEDURE   GetAllPathoTestMasterViewToGenerateReportCategortyWise

  }


  
  GetAllPathoTestMasterViewToGenerateReportViewData(  InvoiceNOs:string, SKUCodes:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
     // return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReport",httpOptions);

   //  http://localhost:49587/

  // return this.http.get("http://localhost:49587/api/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReportView?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);
  
  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReportView?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes,httpOptions);
   
  //  PROCEDURE GetAllPathoTestMasterViewToGenerateReportView

  }

  
  // GetAllPathoTestMasterViewToGenerateReportViewUpdateData(  InvoiceNOs:string, SKUCodes:string , ReportStatuss :string , SampleIds:string  ) {
  //   var httpOptions = {
  //     headers: new HttpHeaders({
  //         'Content-Type': 'application/json',
  //         'Access-Control-Allow-Origin': '*',
  //         'Access-Control-Allow-Credentials': 'true',
  //         'Access-Control-Allow-Headers': 'Content-Type',
  //         'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
  //         'key': 'x-api-key',
  //         'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

  //     })
  // };
  
  
  // return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReportViewUpdate?InvoiceNO="+InvoiceNOs+"&SKUCode="+SKUCodes+"&ReportStatus="+ReportStatuss+"&SampleId="+SampleIds,httpOptions);


  // }
  
  
  GetAllPathoTestMasterViewToGenerateReportViewUpdateData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
  
      })
  };

  // return this.http.post<any>("http://localhost:49587/api/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReportViewUpdate", data
 
  return this.http.post<any>(""+this.apiUrl+"/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReportViewUpdate", data
    
  //    PROCEDURE   GetAllPathoTestMasterViewToGenerateReportViewUpdate
  
  );
  }



  
  GetAllPathoTestMasterViewToGenerateReportViewUpdateAPPROVALData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
  
      })
  };


 // return this.http.post<any>("http://localhost:49587/api/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReportViewUpdateAPPROVAL", data
 
  return this.http.post<any>(""+this.apiUrl+"/ItemMasterAddon/GetAllPathoTestMasterViewToGenerateReportViewUpdateAPPROVAL", data
  
  //  PROCEDURE   GetAllPathoTestMasterViewToGenerateReportViewUpdateApproval
  
  
  
  );
  }

  UploadSelectiveUpdateData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };


  return this.http.post<any>(""+this.apiUrl+"/ItemMasterAddon/UploadSelectiveStatusUpdate", data
  
  //   GetAllPathoTestMasterParameterResultNewSelectionViewUpdate

  
  );
  }
  
  GetAllItemMasterHeaderSubDescByIdSubIdFetch(  ItemMasterHeaderIds : number , ItemMasterHeaderSubIds  : number    ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
      
  };
 

 return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllItemMasterHeaderSubDescByIdSubId?ItemMasterHeaderId="+ItemMasterHeaderIds+"&ItemMasterHeaderSubId="+ItemMasterHeaderSubIds,httpOptions);

   // return this.http.get("http://192.168.0.3:57597/api/ItemMasterAddon/GetAllItemMasterHeaderSubDescByIdSubId?ItemMasterHeaderId="+ItemMasterHeaderIds+"&ItemMasterHeaderSubId="+ItemMasterHeaderSubIds,httpOptions);

    //  PROCEDURE  ItemMasterHeaderSubDescByHeaderIdHeaderSubId


  }

  GetAllItemMasterHeaderSubDescByHeadIdHeaderSubId(  ItemMasterHeaderId:number, ItemMasterHeaderSubId:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  return this.http.get(""+this.apiUrl+"/ItemMasterAddon/GetAllItemMasterHeaderSubDescByHeadIdHeaderSubId?ItemMasterHeaderId="+ItemMasterHeaderId+"&ItemMasterHeaderSubId="+ItemMasterHeaderSubId,httpOptions);

  // PROCEDURE   GetAllItemMasterHeaderSubDescById

  }  



}
